import React from 'react';
import { linkLabel, linkKind } from '../../lib/contactIds';
import { useContact } from '../../context/ContactContext';
import { displaySummary } from '../../lib/summary';
import { isV4 } from '../../lib/uiFlag';

export default function HandoverCard() {
  const { display } = useContact();
  // Console v4 (row 234): CallerCardV4 shows these fields instead.
  if (!display || isV4()) return null;

  const { customer, meta, aiHandled, intents, aiSummary } = display;

  return (
    <div className="handover-card">

      {aiHandled && (
        <div className="ai-tag">
          <span className="ai-tag-dot" />
          AI Handover
        </div>
      )}

      <div className="customer-row">
        <span className="customer-name">{customer.name ?? customer.phone ?? 'Caller'}</span>
        {customer.account && <span className="customer-acct">{customer.account}</span>}
        {customer.plan && <span className="plan-badge">{customer.plan}</span>}
      </div>

      <div className="meta-grid">
        <div>
          <div className="meta-key">Contact ID</div>
          {/* One line with an ellipsis; the full id is the tooltip (Storm's
              live task check, 2026-09-22: the 36-char id wrapped to three
              lines inside a squeezed card and was clipped). */}
          <div className="meta-val meta-val-id" title={meta.contactId}>{meta.contactId}</div>
          {/* D31: a re-offered callback is a new contact each time; say so.
              Row 46: so is a transfer -- label it by initiation method. */}
          {meta.initialContactId && meta.initialContactId !== meta.contactId && (
            <div className="meta-key" style={{ marginTop: 2, textTransform: 'none', letterSpacing: 0 }}>
              {linkLabel(meta.initiationMethod)} · {linkKind(meta.initiationMethod) === 'transfer' ? 'from' : 'chain root'} {String(meta.initialContactId).slice(0, 8)}…
            </div>
          )}
        </div>
        <div>
          <div className="meta-key">Queue</div>
          <div className="meta-val">{meta.queue}</div>
        </div>
        <div>
          <div className="meta-key">Start time</div>
          <div className="meta-val">{meta.startTime}</div>
        </div>
        <div>
          <div className="meta-key">DNIS</div>
          <div className="meta-val">{meta.dnis}</div>
        </div>
      </div>

      {intents.length > 0 && (
        <div className="intent-chips">
          {intents.map(intent => (
            <span key={intent} className="intent-chip">{intent}</span>
          ))}
        </div>
      )}

      {(() => {
        const summary = displaySummary(aiSummary);
        return (
          <div className="ai-summary">
            <div className="ai-summary-title">AI Summary</div>
            <div className="ai-summary-text">
              {summary ?? 'No AI summary available for this call.'}
            </div>
          </div>
        );
      })()}

    </div>
  );
}
